import { useState, useEffect, useCallback } from "react";
import apiFetch from "../../../../shared/services/apiClient";

export function usePresupuesto(anioInicial, mesCorteInicial) {
  const [anio, setAnio] = useState(anioInicial);
  const [mesCorte, setMesCorte] = useState(mesCorteInicial);
  const [arbol, setArbol] = useState([]);
  const [totales, setTotales] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const qs = new URLSearchParams({ anio: String(anio), mes_corte: String(mesCorte) });
      const res = await apiFetch(`/api/finance/presupuesto/?${qs}`);
      const json = await res.json();
      setArbol(json.arbol ?? []);
      setTotales(json.totales ?? null);
    } catch {
    } finally {
      setLoading(false);
    }
  }, [anio, mesCorte]);

  useEffect(() => {
    load();
  }, [load]);

  async function guardar(lineas) {
    setSaving(true);
    try {
      const res = await apiFetch("/api/finance/presupuesto/guardar/", {
        method: "POST",
        body: JSON.stringify({ anio, lineas }),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Error al guardar el presupuesto");
      await load();
      return json;
    } finally {
      setSaving(false);
    }
  }

  return { anio, setAnio, mesCorte, setMesCorte, arbol, totales, loading, saving, guardar };
}
